import React, { useEffect, useState, useRef, createElement } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, PlayCircleIcon } from 'lucide-react';
export function VideoExamples() {
  const [currentVideo, setCurrentVideo] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const videos = [{
    mediaId: 'h4scddj950',
    title: 'Ejemplo de Video IA #1'
  }, {
    mediaId: 'sidiz5rkoc',
    title: 'Ejemplo de Video IA #2'
  }];
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://fast.wistia.com/assets/external/E-v1.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  useEffect(() => {
    // Pause all videos when switching
    if (window.Wistia) {
      videos.forEach((video, index) => {
        if (index !== currentVideo) {
          const wistiaVideo = window.Wistia.api(video.mediaId);
          if (wistiaVideo) {
            wistiaVideo.pause();
          }
        }
      });
    }
  }, [currentVideo]);
  const nextVideo = () => {
    setCurrentVideo(prev => (prev + 1) % videos.length);
  };
  const prevVideo = () => {
    setCurrentVideo(prev => (prev - 1 + videos.length) % videos.length);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const minSwipeDistance = 50;
    if (Math.abs(distance) < minSwipeDistance) return;
    if (distance > 0) {
      nextVideo();
    } else {
      prevVideo();
    }
    setTouchStart(0);
    setTouchEnd(0);
  };
  return <section className="w-full px-4 py-16 md:py-20 bg-gradient-to-b from-slate-900/50 to-purple-900/30" data-id="element-399">
      <div className="max-w-4xl mx-auto" data-id="element-400">
        <div className="text-center mb-10" data-id="element-401">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/20 border border-purple-500/30 rounded-full mb-4" data-id="element-402">
            <PlayCircleIcon className="w-4 h-4 text-purple-300" data-id="element-403" />
            <span className="text-purple-200 text-sm font-medium" data-id="element-404">
              Ejemplos Reales
            </span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-405">
            Mira Videos Creados Con Este Sistema
          </h2>
          <p className="text-base md:text-xl text-gray-400" data-id="element-406">
            Videos profesionales creados en menos de 60 minutos usando IA
          </p>
        </div>
        <div className="relative" data-id="element-407">
          <div className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-4 md:p-6" data-id="element-408">
            <div ref={containerRef} className="relative rounded-lg overflow-hidden bg-slate-900 mx-auto max-w-md touch-pan-y select-none" style={{
            aspectRatio: '9/16'
          }} onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-409">
              {currentVideo === 0 && <div className="absolute inset-0" data-id="element-410">
                  <div className={`wistia_embed wistia_async_${videos[0].mediaId}`} style={{
                width: '100%',
                height: '100%',
                position: 'relative'
              }} data-id="element-411" />
                </div>}
              {currentVideo === 1 && <div className="absolute inset-0" data-id="element-412">
                  <div className={`wistia_embed wistia_async_${videos[1].mediaId}`} style={{
                width: '100%',
                height: '100%',
                position: 'relative'
              }} data-id="element-413" />
                </div>}
            </div>
            <div className="flex items-center justify-between mt-6" data-id="element-414">
              <button onClick={prevVideo} className="p-2 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-colors" aria-label="Video anterior" data-id="element-415">
                <ChevronLeftIcon className="w-6 h-6 text-white" data-id="element-416" />
              </button>
              <div className="flex items-center gap-2" data-id="element-417">
                {videos.map((_, index) => <button key={index} onClick={() => setCurrentVideo(index)} className={`w-2 h-2 rounded-full transition-all ${currentVideo === index ? 'bg-purple-400 w-8' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Ver video ${index + 1}`} data-id="element-418" />)}
              </div>
              <button onClick={nextVideo} className="p-2 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-colors" aria-label="Siguiente video" data-id="element-419">
                <ChevronRightIcon className="w-6 h-6 text-white" data-id="element-420" />
              </button>
            </div>
            <div className="text-center mt-4" data-id="element-421">
              <p className="text-sm md:text-base text-gray-400" data-id="element-422">
                {videos[currentVideo].title}
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-423">
          <p className="text-base md:text-lg text-gray-300" data-id="element-424">
            Estos videos fueron creados usando el mismo sistema que obtendrás
            hoy
          </p>
        </div>
      </div>
    </section>;
}